import memorialEventModel from "../../../modules/models/memorialEventModel";
import ApiService from '../../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            form: {
                id: null,
                photos: [],
                title: null,
                memorial_type: null,
                build_at: null,
                subtitle: null,
                short_description: null,
                description: null,
                slug: null,
                place_details: null,
                latitude: null,
                longitude: null,
                published: true,
                external_links: [{
                    title: null,
                    link: null
                }],
                memorial_events: [{...memorialEventModel}],
                address: null,
                pages: [],
                master_id: null,
            },
            croppedStatus: {
                one_1: true,
                two_1: true,
                two_2: true,
                three_1: true,
                three_2: true,
                three_3: true,
            }
        }
    },
    getters: {
        form: (state) => {
            return state.form;
        },
        croppedStatus: (state) => {
            return state.croppedStatus;
        }
    },
    mutations: {
        setForm(state, value) {
            window.Vue.set(state, 'form', value);
        },
        setCroppedStatus(state, [key, value]) {
            state.croppedStatus[key] = value;
        },
    },
    actions: {
        createMemorial({state}, payload) {
            return new Promise((resolve, reject) => {
                ApiService.post('/memorial', payload)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        editMemorial({state}, payload) {
            return new Promise((resolve, reject) => {
                ApiService.update('/memorial/' + payload.id, payload)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getMemorial({commit}, memorialId) {
            return new Promise((resolve, reject) => {
                ApiService.get('/memorial/' + memorialId)
                    .then((response) => {
                        commit('setForm', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        }
    }
};
